const MINUTE_MS = 60 * 1000;
const HOUR_MS = 60 * MINUTE_MS;
const DAY_MS = 24 * HOUR_MS;
const RELATIVE_CUTOFF_DAYS = 30;
/**
 * FR-004: relative last-activity label for task cards, e.g. "3m ago", "1d ago". Beyond
 * `RELATIVE_CUTOFF_DAYS` a "Nd ago" label stops being useful, so it falls back to a short
 * absolute date instead of growing unboundedly (e.g. "412d ago").
 */
export function formatRelativeTime(iso, now = new Date()) {
    const diffMs = now.getTime() - new Date(iso).getTime();
    if (diffMs < MINUTE_MS)
        return 'just now';
    if (diffMs < HOUR_MS)
        return `${Math.floor(diffMs / MINUTE_MS)}m ago`;
    if (diffMs < DAY_MS)
        return `${Math.floor(diffMs / HOUR_MS)}h ago`;
    const days = Math.floor(diffMs / DAY_MS);
    if (days < RELATIVE_CUTOFF_DAYS)
        return `${days}d ago`;
    return new Intl.DateTimeFormat('en-US', { month: 'short', day: 'numeric' }).format(new Date(iso));
}
